import { createSlice } from '@reduxjs/toolkit'

function verifiedInitialState() {
  // Safe access to process.env with fallbacks
  const railsEnv = (typeof process !== 'undefined' && process.env && process.env.RAILS_ENV) || window.railsEnv || 'development'
  const verifyRecaptcha = (typeof process !== 'undefined' && process.env && process.env.VERIFY_RECAPTCHA) || 'true'

  return railsEnv === 'test' || verifyRecaptcha === 'false' ? true : null
}

export const recaptchaSlice = createSlice({
  name: 'recaptcha',
  initialState: {
    verified: verifiedInitialState(),
  },
  reducers: {
    setVerified: (state, action) => {
      state.verified = action.payload
    },
  },
})

export const {
  setVerified,
} = recaptchaSlice.actions

export const selectVerified = (state) => state.recaptcha.verified

export default recaptchaSlice.reducer
